var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24 12.8525C5.05917 11.6825 4.33333 10.0575 4.33333 8.25914C4.33333 6.46081 5.05917 4.83581 6.24 3.66581L7.77833 5.20414C6.9875 5.98414 6.5 7.06748 6.5 8.25914C6.5 9.45081 6.9875 10.5341 7.7675 11.325L6.24 12.8525ZM15.4267 12.8525C16.6075 11.6825 17.3333 10.0575 17.3333 8.25914C17.3333 6.46081 16.6075 4.83581 15.4267 3.66581L13.8883 5.20414C14.6792 5.98414 15.1667 7.06748 15.1667 8.25914C15.1667 9.45081 14.6792 10.5341 13.8992 11.325L15.4267 12.8525ZM10.8333 6.09248C9.64167 6.09248 8.66667 7.06748 8.66667 8.25914C8.66667 9.45081 9.64167 10.4258 10.8333 10.4258C12.025 10.4258 13 9.45081 13 8.25914C13 7.06748 12.025 6.09248 10.8333 6.09248ZM19.5 8.25914C19.5 10.6533 18.525 12.82 16.9542 14.38L18.4925 15.9183C20.4533 13.9575 21.6667 11.2491 21.6667 8.25914C21.6667 5.26914 20.4533 2.56081 18.4925 0.599976L16.9542 2.13831C17.7623 2.93944 18.4034 3.89296 18.8404 4.94362C19.2774 5.99429 19.5016 7.12122 19.5 8.25914ZM4.7125 2.13831L3.17417 0.599976C1.21333 2.56081 0 5.26914 0 8.25914C0 11.2491 1.21333 13.9575 3.17417 15.9183L4.7125 14.38C3.14167 12.82 2.16667 10.6533 2.16667 8.25914C2.16667 5.86498 3.14167 3.69831 4.7125 2.13831Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSensor);
export default __webpack_public_path__ + "static/media/ic-sensor.5ed5c4474c1f5d0f822ecac9a939e2cb.svg";
export { ForwardRef as ReactComponent };